'use client';

import { useEffect, useState } from 'react';
import { ClientAdUnit } from './ClientAdUnit';

export default function DomainExclusiveAds({ membership }: { membership: any }) {
  const [host, setHost] = useState('');

  useEffect(() => {
    setHost(window.location.hostname);
  }, []);

  const flashgameHosts = ['flashgame.co.kr', 'freegame.co.kr', 'freegames.kr'];

  if (flashgameHosts.includes(host)) {
    return (
      <>
        <ClientAdUnit adSlot="flashgame-autorelaxed" membership={membership} />
        <div style={{ margin: '20px 0' }}></div>
        <ClientAdUnit adSlot="flashgame-in-article" membership={membership} />
      </>
    );
  }

  if (host === 'www.kidszzanggame.com') {
    return (
      <ClientAdUnit adSlot="kidszzang-autorelaxed" membership={membership} />
    );
  }
  
  return null;
} 